import React, {useEffect} from "react";
import ReturnPolicies from "./ReturnPolicies";



export default function SideAccordions({ detail, care }) {

    return (
        <div className="tf-product-side-accordions" id="accordionParent">
            <div className="widget-accordion wd-product-descriptions">
                <div
                    className="accordion-title collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target="#description"
                    aria-expanded="false"
                    aria-controls="description"
                    role="button"
                >
                    <span>Description</span>
                    <span className="icon icon-arrow-down" />
                </div>
                <div
                    id="description"
                    className="collapse"
                    data-bs-parent="#accordionParent"
                >
                    <div className="accordion-body widget-desc">
                        {detail || "No description available."}
                    </div>
                </div>
            </div>

            <div className="widget-accordion wd-product-descriptions">
                <div
                    className="accordion-title collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target="#returnPolicies"
                    aria-expanded="false"
                    aria-controls="returnPolicies"
                    role="button"
                >
                    <span>Product Care</span>
                    <span className="icon icon-arrow-down" />
                </div>
                <div
                    id="returnPolicies"
                    className="collapse"
                    data-bs-parent="#accordionParent"
                >
                    <div className="accordion-body">
                        {care}
                        <ReturnPolicies />
                    </div>
                </div>
            </div>
        </div>
    );
}

